import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {NzMessageService} from "ng-zorro-antd/message";
import {PerFormaAPIService, SnapshotType} from "src/app/services/pfapi.service";
import {FileDownloadService} from "src/app/services/file-download.service";
@Component({
    selector: "app-finreport",
    templateUrl: "./finreport.component.html",
    styleUrls: ["./finreport.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FINReportComponent implements OnInit, OnDestroy {
    constructor(
        private api: PerFormaAPIService,
        private modal: NgbModal,
        private message: NzMessageService,
        private fileDownload: FileDownloadService
    ) {}

    ReportInfo = {
        CustomerNumber: "",
        MinCustomerNumber: "",
        MaxCustomerNumber: "",
        Copies: 1,
        Printer: "",
        ServiceInvoice: true,
        SalesInvoice: true,
        PartsInvoice: true,
        RentalInvoice: true,
        AdjustmentNote: true,
        PartsCreditMemo: true,
        ServiceCreditMemo: true,
        SelectedCustomers: [],
        NewCustomerNum: "",
        StartDate: "",
        RunType: "customerNumber",
        EndDate: ""
    };
    JobLogFilter = {Search: ""};
    CurrentJob = null;
    // active report tab: "general" or "jobs"
    activeTab = "general";
    // progress percent for the running-report progress bar
    ProgressPercent = 0;
    // Set vars to necessary default values.
    Loading = true;
    Page = 1;
    // Set paging options.
    DisplayOptions = [5, 10, 20, 50];
    // Set default page.
    PageSize = 10;
    PreviouslyRunning = false;
    RunningReports = "";
    Interval;
    FINData;
    ARData;
    PageTotal;
    Results;
    ReportStatus: any = {};
    Jobs: any[] = [];
    JobLogs: any[] = [];
    ModalOptions = {animation: false, backdropClass: "backdrop"};

    ngOnDestroy(): void {
        if (this.Interval) {
            clearInterval(this.Interval);
        }
    }

    ngOnInit(): void {
        const request = {
            Page: this.Page,
            PageSize: this.PageSize
        };

        // Retrieve the customer list
        this.api.getApiReportFinInfo().subscribe({
            next: data => {
                this.FINData = data;
            }
        });

        // Called when the ng-controller first loads.
        this.api.getApiReportFinStatus().subscribe(data => {
            this.ARData = data;
            this.api.postApiReportFinJobs(request).subscribe(data2 => {
                this.Jobs = data2.Jobs ?? [];
                this.Page = data2.Page;
                this.Results = data2.TotalItems;
                this.PageTotal = data2.TotalPages;
                this.PageSize = data2.PageSize;
                this.Loading = false;
            });
        });

        if (!this.Interval) {
            this.initRefresh();
        }
    }

    addCustomer = () => {
        if (!this.ReportInfo.NewCustomerNum) return;
        this.api
            .postApiReportFinCustomers({
                CustomerId: this.ReportInfo.NewCustomerNum
            })
            .subscribe(() => {
                this.ReportInfo.NewCustomerNum = "";
                this.api.getApiReportFinInfo().subscribe(data2 => {
                    this.FINData = data2;
                });
            });
    };

    removeCustomer = () => {
        if (this.ReportInfo.SelectedCustomers.length === 0) return;
        this.api
            .postApiReportFinCustomersDelete({
                CustomerId: this.ReportInfo.SelectedCustomers.join(",")
            })
            .subscribe(() => {
                this.ReportInfo.SelectedCustomers = [];
                this.api.getApiReportFinInfo().subscribe(data2 => {
                    this.FINData = data2;
                });
            });
    };

    initRefresh = () => {
        this.Interval = setInterval(() => {
            this.api.getApiReportFinStatus().subscribe(data => {
                if (data.ReportDone == true) {
                    this.ReportStatus = data;
                    if (this.PreviouslyRunning) {
                        this.message.success("A report job has finished", {nzDuration: 30000});
                        this.modal.dismissAll();
                        this.PreviouslyRunning = false;
                        this.Refresh();
                    }
                } else {
                    if (this.PreviouslyRunning == false) {
                        this.PreviouslyRunning = true;
                        this.Refresh();
                    }
                    this.ReportStatus = data;
                    this.Loading = false;
                    const percent = (Number(data.DocumentsDone) / Number(data.DocumentsTodo)) * 100;
                    this.ProgressPercent = isNaN(percent) ? 0 : Math.round(percent);
                }
                this.GetRunningReports();
            });
        }, 1000);
    };

    GetRunningReports = () => {
        if (this.ReportStatus != null && this.ReportStatus.ReportDone != true) {
            this.RunningReports = "1";
        } else {
            this.RunningReports = "";
        }
    };

    ViewJobLogFile = JobLog => {
        this.fileDownload.viewReportJobLogFile("fin", JobLog.JobUniqueID, JobLog.JobLogID);
    };

    ShowJobLog = (mdl, Job) => {
        this.CurrentJob = Job;
        this.JobLogFilter.Search = "";
        this.Loading = true;
        this.api.getApiReportFinJobsJobGuidLogs(Job.JobUniqueID).subscribe(data => {
            // Initialize.
            this.modal.open(mdl, this.ModalOptions);
            this.Loading = false;
            this.JobLogs = data;
        });
    };

    ShowJobInfo = (mdl, Job) => {
        this.CurrentJob = Job;
        this.modal.open(mdl, this.ModalOptions);
    };

    GetDateFromString = s => {
        if (s != null) {
            const localDate = new Date(s);
            return localDate.toLocaleDateString() + " " + localDate.toLocaleTimeString();
        } else return "";
    };

    GoBack = () => {
        this.Loading = true;
        this.Page--;
        this.ngOnInit();
    };

    GoNext = () => {
        this.Loading = true;
        this.Page++;
        this.ngOnInit();
    };

    DownloadFile = Job => {
        this.fileDownload.downloadReportJobFile("fin", Job.JobUniqueID);
    };

    DeleteJob = Job => {
        this.Loading = true;
        this.api.deleteApiReportFinJobsJobGuid(Job.JobUniqueID).subscribe(() => {
            // Initialize.
            this.ngOnInit();
            this.message.success("Report deleted successfully");
        });
    };

    Refresh = () => {
        this.Loading = true;
        // Initialize.
        this.ngOnInit();
    };

    DisplayChanged = () => {
        this.Loading = true;
        // Reset page to 1.
        this.Page = 1;

        // Initialize.
        this.ngOnInit();
    };

    ShowJobProgress = modal => {
        this.modal.open(modal, this.ModalOptions);
    };

    RunPrintReport = prms => {
        if (!prms.StartDate || !prms.EndDate) {
            // Notification.
            this.message.error("Please specify a start and end date");
            return;
        }
        const attachTypes: SnapshotType[] = [];
        if (prms.PartsInvoice) {
            attachTypes.push(0);
        }
        if (prms.ServiceInvoice) {
            attachTypes.push(1);
        }
        if (prms.RentalInvoice) {
            attachTypes.push(2);
        }
        if (prms.SalesInvoice) {
            attachTypes.push(3);
        }
        if (prms.AdjustmentNote) {
            attachTypes.push(4);
        }
        if (prms.PartsCreditMemo) {
            attachTypes.push(5);
        }
        if (prms.ServiceCreditMemo) {
            attachTypes.push(6);
        }
        if (attachTypes.length == 0) {
            this.message.error("Please specify one or more attachment types");
            return;
        }
        if (prms.RunType == "customerRange" && (!prms.MinCustomerNumber || !prms.MaxCustomerNumber)) {
            this.message.error("Please specify start and end customer range");
            return;
        }
        if (prms.RunType == "customerNumber" && !prms.CustomerNumber) {
            this.message.error("Please specify customer number");
            return;
        }
        const requestData = {
            SnapshotTypes: attachTypes,
            CustomerNumber: prms.CustomerNumber,
            MinCustomerNumber: prms.MinCustomerNumber,
            MaxCustomerNumber: prms.MaxCustomerNumber,
            StartDate: prms.StartDate,
            EndDate: prms.EndDate,
            Copies: prms.Copies,
            Printer: prms.Printer,
            RunFromList: prms.RunType === "customerList"
        };
        console.log(requestData);
        this.Loading = true;
        this.api.postApiReportFinRun(requestData).subscribe(() => {
            // Initialize.
            this.ngOnInit();

            // Clear fields.
            prms.CustomerNumber = null;
            prms.MinCustomerNumber = null;
            prms.MaxCustomerNumber = null;
            prms.EndDate = null;
            prms.StartDate = null;
            prms.Copies = 1;
            prms.Printer = null;

            // Notification.
            this.message.success("Report queued successfully");
        });
    };
}
